(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/race-navigation/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/racing/race-navigation/assets/javascripts/prescript.js');

svs = svs || {};
svs.racing = svs.racing || {};
svs.racing.navigation = svs.racing.navigation || {};


 })(window);